import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { ERewardAssetType } from "../@types/appConfig.js";
import { getApiSdk } from "../graphql/client/api.js";
export const useRewardAssetMetadata = (assetIds) => {
    const realAssetIds = useMemo(() => {
        return (assetIds ||
            window.__APP_CONFIG.rewardAssets
                .filter(({ type }) => type === ERewardAssetType.ASSET)
                .map(({ policyId, assetName }) => `${policyId}.${assetName}`));
    }, [assetIds]);
    return useQuery(["metadata-array", realAssetIds], async () => {
        const { getAssets } = await getApiSdk();
        const results = await getAssets({ ids: realAssetIds }).then((res) => res.assets.byIds);
        return results;
    }, {
        initialData: [],
        enabled: realAssetIds.length > 0,
        cacheTime: 1000 * 60 * 60 * 24 * 7, // 7 days
    });
};
//# sourceMappingURL=useRewardAssetMetadata.js.map